import React from "react";
import "./openTradesRanking.css";
import useOpenTradesRanking from "../../hooks/useOpenTradesRanking";

function OpenTradesRanking({ className }) {
  const { openTradesRanking, loadingOpenTradesRanking } =
    useOpenTradesRanking();

  if (loadingOpenTradesRanking) {
    return (
      <div
        className={`orion__open-trades-ranking-container ${className || ""}`}
      >
        <div className="orion__open-trades-ranking-table">
          <div className="orion__open-trades-ranking-loading">
            <div className="orion__open-trades-ranking-loading-text">
              Carregando sinais abertos...
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={`orion__open-trades-ranking-container ${className || ""}`}>
      <div className="orion__open-trades-ranking-table">
        <div className="orion__open-trades-ranking-header">
          <h3 className="orion__open-trades-ranking-title">Sinais abertos</h3>
          <div className="orion__open-trades-ranking-live-indicator">
            <div className="orion__open-trades-ranking-live-dot"></div>
            <span>AO VIVO</span>
          </div>
        </div>

        <div className="orion__open-trades-ranking-list">
          {openTradesRanking.slice(0, 5).map((trade, index) => {
            const profitNumber = trade.formatted.profitNumber;
            const profitString = trade.formatted.profit;

            const maxProfit =
              openTradesRanking.length > 0
                ? Math.max(
                    ...openTradesRanking
                      .slice(0, 5)
                      .map((t) => t.formatted.profitNumber),
                  )
                : 100;
            const normalizedWidth = (profitNumber / maxProfit) * 85;
            const progressWidth = Math.min(Math.max(normalizedWidth, 5), 85);

            return (
              <div
                key={trade.pair || index}
                className="orion__open-trades-ranking-asset"
              >
                <div className="orion__open-trades-ranking-asset-header">
                  <div className="orion__open-trades-ranking-left-section">
                    <div className="orion__open-trades-ranking-position">
                      {index + 1}
                    </div>
                    <div className="orion__open-trades-ranking-asset-info">
                      <div className="orion__open-trades-ranking-asset-name">
                        {trade.name || "N/A"}
                      </div>
                      <div className="orion__open-trades-ranking-pair-name">
                        {trade.pair}
                      </div>
                      <div className="orion__open-trades-ranking-pair-name">
                        {trade.formatted.purchaseDate}
                      </div>
                    </div>
                  </div>
                  <div className="orion__open-trades-ranking-profit">
                    {profitString}
                  </div>
                </div>

                <div className="orion__open-trades-ranking-progress-container">
                  <div
                    className="orion__open-trades-ranking-progress-bar orion__open-trades-ranking-progress-positive"
                    style={{ width: `${progressWidth}%` }}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default OpenTradesRanking;
